import { render, staticRenderFns } from "./organization-list.vue?vue&type=template&id=70a585b3&scoped=true&"
import script from "./organization-list.vue?vue&type=script&lang=ts&"
export * from "./organization-list.vue?vue&type=script&lang=ts&"
import style0 from "./organization-list.vue?vue&type=style&index=0&id=70a585b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a585b3",
  null
  
)

export default component.exports